import { DatePicker } from '@idaho-aeyc/ui-kit';
import { styled } from 'styled-components';

export const SDatePicker = styled(DatePicker)``;
